module.exports = __webpack_public_path__ + "static/img/DO.66940827.png";